<span class="badge badge-pedido-status badge-pedido-status-revisao">
    {{status.nome}}
</span>